import { usePostDocumentNotes } from 'entities/document/api';

export const useRemoveNote = (documentId?: number) => {
  const { mutateAsync } = usePostDocumentNotes(documentId);

  const removeNote = async () => {
    await mutateAsync(null);
  };

  return { removeNote };
};
